import { EnvironmentProviders } from '@angular/core';
import { PrimeNGConfigType, providePrimeNG } from 'primeng/config';
import { provideDialogStackService } from '@bindoc-projects/ui-lib/dialog/registration';

/**
 * Frontend app-config key holding the PrimeUI licence.
 *
 * The licence is deployment configuration, not source: it is rendered into
 * `/config.json` from an environment variable like every other app variable —
 * the same treatment `BD_MAP_ACCESS_TOKEN_MAPBOX` gets. That keeps the key
 * rotatable without a rebuild and keeps a JWT out of the repository. Apps that
 * want it must list this key in their `BdAppConfigRequest.variableKeys`.
 */
export const BD_PRIMEUI_LICENSE_KEY = 'BD_PRIMEUI_LICENSE';

/**
 * Returns `primeNgConfig` with the PrimeUI licence from the loaded app config.
 *
 * A missing key is not an error — PrimeNG then falls back to its unlicensed
 * mode and shows the standard banner, which is what every environment without
 * the variable configured should do.
 */
export function withPrimeUiLicense(
  primeNgConfig: PrimeNGConfigType,
  appConfig: { variables: { [key: string]: string } },
): PrimeNGConfigType {
  const license = appConfig.variables[BD_PRIMEUI_LICENSE_KEY];

  return license ? { ...primeNgConfig, license } : primeNgConfig;
}

export function provideUiTheme(
  primeNgConfig: PrimeNGConfigType,
): EnvironmentProviders[] {
  return [providePrimeNG(primeNgConfig), provideDialogStackService()];
}
